import { useEffect, useRef, useState } from "react";
import {
  Box,
  TableCell,
  TableRow,
  Stack,
  TextField,
  Button,
  IconButton,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import {
  DateFormater,
  formatAmount,
  handleSessionOut,
} from "../../../../../HelperFunctions/HelperFunctions";
import BatchAmountTable from "./BatchAmountTable";
import NimbleAmountTable from "./NimbleAmountTable";
import MatchedAmountTable from "./MatchedAmountTable";
import { enqueueSnackbar } from "notistack";
import ChargebacksOrFeeTable from "./ChargebacksOrFeeTable";
import { useRouteLoaderData } from "react-router-dom";
import RefreshIcon from "@mui/icons-material/Refresh";
import { updateSalesData } from "../../../../../API/backendAPI";
import SecurityLockDialog from "../SecurityLockDialog/SecurityLockDialog";
import { userApproval, userSecurity } from "../../../../../API/nimbleAPI";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const ExpandableContentRow = ({
  data,
  tab,
  section,
  handleLinkBatch,
  linkBatch,
  merchantDetails,
  setLinkBatch,
  setLoading,
  setDiffAmt,
  getReconciliationDetails,
  selectedCorp,
  batchTablePage,
  setBatchTablePage,
  nimbleTablePage,
  setNimbleTablePage,
  matchedTablePage,
  setMatchedTablePage,
  chargebackTablePage,
  setChargebackTablePage,
  saveScrollPosition,
  getScrollPosition,

  batchCardCache,
  nimbleCardsCache,
}) => {
  const cacheKey = `${tab}-${section}`;
  const cards = [
    // { cardName: "--Select--", cardType: "" },
    { cardName: "--All--", cardType: "" },
    ...Array.from(
      new Set(data?.unreconciled_merchants?.map((item) => item.card_type)),
    )
      .map((card) => ({ cardName: card, cardType: card }))
      .sort((a, b) => a.cardName.localeCompare(b.cardName)),
  ];

  const { Previlage, journal, Status } = useRouteLoaderData("reconciliation");
  const [reconIds, setReconIds] = useState([]);
  const [openSecurityDialog, setOpenSecurityDialog] = useState(false);

  const nimbleCreditCards = [
    { cardName: "--All--", cardType: "" },
    ...Array.from(
      new Set(data?.unreconciled_sales?.map((item) => item.card_type)),
    )
      .map((card) => ({ cardName: card, cardType: card }))
      .sort((a, b) => a.cardName.localeCompare(b.cardName)),
  ];

  // const Status = 2;

  // const [batchCard, setBatchCard] = useState([cards[0]?.cardType || ""]);
  // const [nimbleCards, setNimbleCards] = useState([
  //   nimbleCreditCards[0]?.cardType || "",
  // ]);
  const [batchCard, setBatchCard] = useState(
    batchCardCache[cacheKey] || [cards[0]?.cardType || ""],
  );

  const [nimbleCards, setNimbleCards] = useState(
    nimbleCardsCache[cacheKey] || [nimbleCreditCards[0]?.cardType || ""],
  );
  const isReadOnly = cards.filter((card) => card.cardType !== "").length === 1;
  const isNimbleCardReadOnly =
    nimbleCreditCards.filter((card) => card.cardType !== "").length === 1;

  const [batchAmount, setBatchAmount] = useState(0);
  const [nimbleAmount, setNimbleAmount] = useState(0);
  const diffAmount = batchAmount - nimbleAmount;

  const BatchData =
    batchCard && batchCard.length > 0 && !batchCard.includes("")
      ? data?.unreconciled_merchants?.filter((item) =>
        batchCard.some(
          (cardType) =>
            item.card_type?.toLowerCase() === cardType.toLowerCase(),
        ),
      )
      : data?.unreconciled_merchants || [];

  const NimbleData =
    nimbleCards && nimbleCards.length > 0 && !nimbleCards.includes("")
      ? data?.unreconciled_sales?.filter((item) =>
        nimbleCards.some(
          (cardType) =>
            item.card_type?.toLowerCase() === cardType.toLowerCase(),
        ),
      )
      : data?.unreconciled_sales || [];

  useEffect(() => {
    setDiffAmt(batchAmount - nimbleAmount);
  }, [batchAmount, nimbleAmount]);

  useEffect(() => {
    batchCardCache[cacheKey] = batchCard;
  }, [batchCard, cacheKey]);

  useEffect(() => {
    nimbleCardsCache[cacheKey] = nimbleCards;
  }, [nimbleCards, cacheKey]);

  // useEffect(() => {
  //   if (merchantDetails?.cards_data?.length) {
  //     const ids = merchantDetails.cards_data.map((item) => item.recon_uniq_id);
  //     setReconIds(ids);
  //   } else {
  //     setReconIds([]);
  //   }
  // }, [merchantDetails]);

  const handleUpdateSalesData = async () => {
    // const reconUniqIds =
    //   merchantDetails?.cards_data?.map((item) => item.recon_uniq_ids  ) || [];
    const reconUniqIds =
      merchantDetails?.cards_data?.flatMap((item) => item.recon_uniq_ids) || [];

    if (!reconUniqIds.length) {
      enqueueSnackbar("No reconciliation IDs found", {
        variant: "warning",
      });
      return;
    }

    try {
      setLoading(true);
      const updatedSale = await updateSalesData(reconUniqIds);
      // const updatedSale = await updateSalesData({
      //   reconUniqIds,
      //   status: Status === 1 ? 1 : 0,
      // });
      const allSuccess = updatedSale.every((item) => item.status_code === 200);
      const sessionout = updatedSale.every((item) => item.status_code === 401);

      if (allSuccess) {
        await getReconciliationDetails(tab);
        setNimbleAmount(0);
      } else if (sessionout) {
        handleSessionOut();
      } else {
        alert("all are not sucess");
      }
    } catch (error) {
      enqueueSnackbar("Failed to update sales data", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <TableRow sx={{ height: "100%" }}>
      <TableCell
        colSpan={2}
        sx={{ p: 0, border: "1px solid #e0e0e0", height: "100%" }}
      >
        {section === "To be Matched" && (
          <Stack direction={"row"} height={"100%"}>
            <Box width={"50%"} height={"100%"} p={1} flex={1}>
              <Stack direction={"row"} justifyContent={"space-between"} gap={1}>
                <FormControl
                  size="small"
                  variant="filled"
                  sx={{ maxWidth: "140px", flexGrow: 1 }}
                  disabled={isReadOnly}
                >
                  <InputLabel id="batch-card-type-label">Card Type</InputLabel>
                  <Select
                    multiple
                    labelId="batch-card-type-label"
                    value={Array.isArray(batchCard) ? batchCard : []}
                    onChange={(e) => {
                      const selectedCardTypes = e.target.value;
                      const currentSelection = Array.isArray(batchCard)
                        ? batchCard
                        : [];
                      const wasAllSelected = currentSelection.includes("");
                      const isAllSelected = selectedCardTypes.includes("");
                      const hasOtherSelections =
                        selectedCardTypes.filter((type) => type !== "").length >
                        0;

                      let newSelection;

                      if (
                        isAllSelected &&
                        !wasAllSelected &&
                        hasOtherSelections
                      ) {
                        newSelection = [""];
                      } else if (
                        isAllSelected &&
                        wasAllSelected &&
                        hasOtherSelections
                      ) {
                        newSelection = selectedCardTypes.filter(
                          (type) => type !== "",
                        );
                      } else if (
                        isAllSelected &&
                        selectedCardTypes.length === 1
                      ) {
                        newSelection = [""];
                      } else if (selectedCardTypes.length === 0) {
                        newSelection = [""];
                      } else {
                        newSelection = selectedCardTypes.filter(
                          (type) => type !== "",
                        );
                      }

                      setBatchCard(newSelection);
                    }}
                    label="Card Type"
                    renderValue={(selected) => {
                      if (!selected || selected.length === 0) {
                        return <em>--All--</em>;
                      }
                      if (selected.includes("")) {
                        return <em>--All--</em>;
                      }
                      // return selected
                      //   .map((cardType) => {
                      //     const card = cards.find(
                      //       (c) => c.cardType === cardType
                      //     );
                      //     return card?.cardName || cardType;
                      //   })
                      //   .join(", ");
                      const selectedText = selected
                        .map((cardType) => {
                          const card = cards.find(
                            (c) => c.cardType === cardType,
                          );
                          return card?.cardName || cardType;
                        })
                        .join(", ");
                      return (
                        <span
                          title={selectedText}
                          style={{
                            display: "inline-block",
                            maxWidth: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {selectedText}
                        </span>
                      );
                    }}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300,
                        },
                      },
                    }}
                  >
                    {cards.map((card) => (
                      <MenuItem key={card.cardType} value={card.cardType}>
                        {card.cardName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  variant="filled"
                  label="Batch Amount"
                  value={formatAmount(batchAmount)}
                  sx={{ maxWidth: "250px", flexGrow: 1 }}
                  InputProps={{
                    readOnly: true,
                    sx: { input: { textAlign: "right", fontSize: 13 } },
                  }}
                />
                <TextField
                  id="filled-read-only-input"
                  variant="filled"
                  label="Open / Difference Amount"
                  value={formatAmount(diffAmount)}
                  InputProps={{
                    readOnly: true,
                    sx: { input: { textAlign: "right", fontSize: 13 } },
                  }}
                />
              </Stack>

              <Box sx={{ flexGrow: 1, minHeight: 0 }}>
                <BatchAmountTable
                  data={BatchData}
                  setBatchAmount={setBatchAmount}
                  batchCard={batchCard}
                  setLinkBatch={setLinkBatch}
                  linkBatch={linkBatch}
                  page={batchTablePage}
                  setPage={setBatchTablePage}
                  tab={tab}
                  section={section}
                  saveScrollPosition={saveScrollPosition}
                  getScrollPosition={getScrollPosition}
                />
              </Box>
            </Box>
            <Box width={"50%"} height={"100%"} p={1} flex={1}>
              <Stack direction={"row"} justifyContent={"space-between"} gap={1}>
                <FormControl
                  size="small"
                  variant="filled"
                  sx={{ maxWidth: "140px", flexGrow: 1 }}
                  disabled={isNimbleCardReadOnly}
                >
                  <InputLabel id="nimble-card-type-label">Card Type</InputLabel>
                  <Select
                    multiple
                    labelId="nimble-card-type-label"
                    value={Array.isArray(nimbleCards) ? nimbleCards : []}
                    onChange={(e) => {
                      const selectedCardTypes = e.target.value;
                      const currentSelection = Array.isArray(nimbleCards)
                        ? nimbleCards
                        : [];
                      const wasAllSelected = currentSelection.includes("");
                      const isAllSelected = selectedCardTypes.includes("");
                      const hasOtherSelections =
                        selectedCardTypes.filter((type) => type !== "").length >
                        0;

                      let newSelection;

                      if (
                        isAllSelected &&
                        !wasAllSelected &&
                        hasOtherSelections
                      ) {
                        newSelection = [""];
                      } else if (
                        isAllSelected &&
                        wasAllSelected &&
                        hasOtherSelections
                      ) {
                        newSelection = selectedCardTypes.filter(
                          (type) => type !== "",
                        );
                      } else if (
                        isAllSelected &&
                        selectedCardTypes.length === 1
                      ) {
                        newSelection = [""];
                      } else if (selectedCardTypes.length === 0) {
                        newSelection = [""];
                      } else {
                        newSelection = selectedCardTypes.filter(
                          (type) => type !== "",
                        );
                      }

                      setNimbleCards(newSelection);
                    }}
                    label="Card Type"
                    renderValue={(selected) => {
                      if (!selected || selected.length === 0) {
                        return <em>--All--</em>;
                      }
                      if (selected.includes("")) {
                        return <em>--All--</em>;
                      }
                      const selectedText = selected
                        .map((cardType) => {
                          const card = nimbleCreditCards.find(
                            (c) => c.cardType === cardType,
                          );
                          return card?.cardName || cardType;
                        })
                        .join(", ");
                      return (
                        <span
                          title={selectedText}
                          style={{
                            display: "inline-block",
                            maxWidth: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {selectedText}
                        </span>
                      );
                    }}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300,
                        },
                      },
                    }}
                  >
                    {nimbleCreditCards.map((card) => (
                      <MenuItem key={card.cardType} value={card.cardType}>
                        {card.cardName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  variant="filled"
                  label="Nimble receipt amount"
                  // value={nimbleAmount}
                  value={formatAmount(nimbleAmount)}
                  sx={{ maxWidth: "250px", flexGrow: 1 }}
                  InputProps={{
                    readOnly: true,
                    sx: { input: { textAlign: "right", fontSize: 13 } },
                  }}
                />

                <Tooltip title="Refresh">
                  <IconButton
                    onClick={handleUpdateSalesData}
                    // onClick={() => {
                    //   if (!window.confirm("Are you sure you want to refresh the sales data?")) return;
                    //   handleUpdateSalesData();
                    // }}
                    sx={{
                      width: 40,
                      height: 40,
                      "&:hover": {
                        color: "primary.main",
                      },
                    }}
                  >
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>

                <Button
                  size="small"
                  disableElevation
                  variant="contained"
                  color="black"
                  sx={{
                    backgroundColor: "#b5dcf2",
                    textTransform: "none",
                    px: 5,
                  }}
                  // onClick={() => handleLinkBatch()}
                  onClick={async () => {
                    if (!Previlage?.[0]?.Update) {
                      enqueueSnackbar(
                        "You do not have permission to link batches.",
                        {
                          variant: "error",
                        },
                      );
                      return;
                    }
                    if (Status === 1 && (diffAmount > 0 || diffAmount < 0)) {
                      enqueueSnackbar("The user doesn't have approval privileges to post/match the transactions", {
                        variant: "warning",
                      });
                      return;
                    }
                    if (journal?.Create !== true) {
                      enqueueSnackbar(
                        "The user doesn't have journal entry approval privileges to post/match the transactions",
                        {
                          variant: "error",
                        },
                      );
                      return;
                    }
                    // const { Status } = await userApproval();
                    // console.log("this is status from linkbatch",Status)



                    try {
                      // Determine type based on diffAmount: negative = 20, zero or positive = 158
                      const type = diffAmount < 0 ? 20 : 158;

                      const payload = {
                        corpID: selectedCorp?.ID,
                        booksDate: dayjs()
                          .utc()
                          .startOf("day")
                          .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
                        type: type,
                      };

                      const security = await userSecurity(payload);

                      if (security) {
                        setOpenSecurityDialog(true);
                        return;
                      }
                    } catch (error) {
                      console.error(error);
                      enqueueSnackbar("Failed to check security status.", {
                        variant: "error",
                      });
                    }

                    const normalizedMerchantIds = [
                      ...new Set(linkBatch?.merchant_ids || []),
                    ].filter((id) => BatchData.some((item) => item._id === id));
                    const normalizedSaleIds = [
                      ...new Set(linkBatch?.sale_ids || []),
                    ].filter((id) =>
                      NimbleData.some((item) => item._id === id),
                    );

                    const selectedMerchants = BatchData.filter((m) =>
                      normalizedMerchantIds.includes(m._id),
                    );

                    const selectedSales = NimbleData.filter((s) =>
                      normalizedSaleIds.includes(s._id),
                    );

                    if (
                      selectedMerchants.length === 0 ||
                      selectedSales.length === 0
                    ) {
                      enqueueSnackbar(
                        "Please select batch and nimble rows before linking.",
                        { variant: "warning" },
                      );
                      return;
                    }

                    const merchantCardTypes = [
                      ...new Set(
                        selectedMerchants.map((m) =>
                          m.card_type?.toLowerCase(),
                        ),
                      ),
                    ];
                    const saleCardTypes = [
                      ...new Set(
                        selectedSales.map((s) => s.card_type?.toLowerCase()),
                      ),
                    ];

                    // if (diffAmount < 0 && selectedSales.length > 1) {
                    //   enqueueSnackbar(
                    //     "Matching can't be done as multiple daily sales are involved.",
                    //     {
                    //       variant: "warning",
                    //     },
                    //   );
                    //   return;
                    // }

                    const getMinDate = (arr, key) =>
                      new Date(Math.min(...arr.map((i) => new Date(i[key]))));
                    const getMaxDate = (arr, key) =>
                      new Date(Math.max(...arr.map((i) => new Date(i[key]))));

                    const Valid =
                      getMinDate(selectedMerchants, "settlement_date") >=
                      getMinDate(selectedSales, "sale_date") &&
                      getMaxDate(selectedMerchants, "settlement_date") >=
                      getMaxDate(selectedSales, "sale_date");


                    // Helper function to check if card type is visa/mastercard variant
                    const isVisaMastercardVariant = (type) =>
                      [
                        "visa",
                        "mastercard",
                        "chase credit",
                        "chase debit",
                        "chasecredit",
                        "chasedebit"
                      ].includes(type);

                    const isValid =
                      // Case 1: Single merchant card type matches single sale card type
                      (merchantCardTypes.length === 1 &&
                        saleCardTypes.length === 1 &&
                        (merchantCardTypes[0] === saleCardTypes[0] ||
                          (isVisaMastercardVariant(merchantCardTypes[0]) &&
                            saleCardTypes[0] === "visa & mastercard"))) ||
                      // Case 2: Multiple merchant card types (visa and mastercard) match "visa & mastercard" in sale
                      (merchantCardTypes.length > 1 &&
                        merchantCardTypes.every((type) =>
                          isVisaMastercardVariant(type),
                        ) &&
                        saleCardTypes.length === 1 &&
                        saleCardTypes[0] === "visa & mastercard") ||
                      // Case 3: All merchant card types are visa/mastercard variants and sale has matching single type
                      (merchantCardTypes.length > 1 &&
                        merchantCardTypes.every((type) =>
                          isVisaMastercardVariant(type),
                        ) &&
                        saleCardTypes.length === 1 &&
                        merchantCardTypes.includes(saleCardTypes[0])) ||
                      // Case 4: Multiple batch entries with same visa/mastercard variant (visa) match "visa & mastercard" in nimble
                      (merchantCardTypes.length === 1 &&
                        merchantCardTypes[0] === "visa" &&
                        saleCardTypes.length === 1 &&
                        saleCardTypes[0] === "visa & mastercard") ||
                      // Case 5: Multiple batch entries with same visa/mastercard variant (mastercard) match "visa & mastercard" in nimble
                      (merchantCardTypes.length === 1 &&
                        merchantCardTypes[0] === "mastercard" &&
                        saleCardTypes.length === 1 &&
                        saleCardTypes[0] === "visa & mastercard");

                    if (!isValid) {
                      enqueueSnackbar(
                        "Batch and Nimble must have the same Card Type!",
                        { variant: "warning" },
                      );
                      return
                    }
                    else if (!Valid) {
                      enqueueSnackbar(
                        "Batch date should be greater than or equal to the daily sales date",
                        { variant: "warning" },
                      );
                      return;
                    }
                    else if (diffAmount < 0 && selectedSales.length > 1) {
                      enqueueSnackbar(
                        "Matching can't be done as multiple daily sales are involved.",
                        {
                          variant: "warning",
                        },
                      );
                      return;
                    }
                    else {
                      const success = await handleLinkBatch({
                        merchant_ids: normalizedMerchantIds,
                        sale_ids: normalizedSaleIds,
                      });
                      if (success) {
                        setBatchAmount(0);
                        setNimbleAmount(0);
                      }
                    }

                    // handleLinkBatch();
                  }}
                >
                  Link Batch
                </Button>
              </Stack>

              <Box sx={{ flexGrow: 1, minHeight: 0 }}>
                <NimbleAmountTable
                  data={NimbleData}
                  setNimbleAmount={setNimbleAmount}
                  nimbleCards={nimbleCards}
                  setLinkBatch={setLinkBatch}
                  linkBatch={linkBatch}
                  page={nimbleTablePage}
                  setPage={setNimbleTablePage}
                  tab={tab}
                  section={section}
                  saveScrollPosition={saveScrollPosition}
                  getScrollPosition={getScrollPosition}
                  handleUpdateSalesData={handleUpdateSalesData}
                />
              </Box>
            </Box>
          </Stack>
        )}

        {section === "Matched" && (
          <MatchedAmountTable
            data={data}
            page={matchedTablePage}
            setPage={setMatchedTablePage}
          />
        )}
        {section === "Chargebacks / Fee" && (
          <ChargebacksOrFeeTable
            data={data}
            page={chargebackTablePage}
            setPage={setChargebackTablePage}
          />
        )}
        <SecurityLockDialog
          open={openSecurityDialog}
          onClose={() => setOpenSecurityDialog(false)}
          onSuccess={() => {
            setOpenSecurityDialog(false);
          }}
        />
      </TableCell>
    </TableRow>
  );
};

export default ExpandableContentRow;
